import * as React from "react";
import { Button, Margin, P, ErrorNotification } from "@ovotech/element";
import { useNavigate } from "react-router";
import { Page } from "_core/components/Page";
import { ProductUrls } from "_core/types/enums";
import { useStore } from "_core/store";
import { performRequote } from "_core/utils/performRequote";
import { useConfig } from "_core/utils/config";
import { LoadingSkeleton } from "_core/components/LoadingSkeleton";
import Mixpanel from "_core/analytics/Mixpanel";
import { AnalyticsEvents } from "_core/analytics/AnalyticsEvents";

export const QuoteExpired = () => {
  const navigate = useNavigate();

  const { API_URL } = useConfig();
  const { externalId, postcode } = useStore();
  const [isLoading, setIsLoading] = React.useState(false);

  const requestRequote = () => {
    if (!externalId || !postcode) return;
    Mixpanel.track(AnalyticsEvents.CLICKEDBUTTON, {
      buttonId: "request-requote",
      pageName: ProductUrls.Expired,
    });
    setIsLoading(true);
    performRequote(
      { externalId, postcode },
      () => {
        setIsLoading(false);
      },
      API_URL,
      navigate
    );
  };

  return isLoading ? (
    <LoadingSkeleton />
  ) : (
    <>
      <Page title="" subtitle="" url={ProductUrls.Expired}>
        <ErrorNotification
          id="sorry"
          title="Your installation quote has expired"
          style={{ marginBottom: "4rem" }}
        >
          <P>
            Our quotes are only valid for 30 days because prices can change.{" "}
          </P>
          <P>If you’d like a new quote, click the button below.</P>
        </ErrorNotification>

        <Margin top={8} />
        <Button onClick={() => requestRequote()}>Get a new quote</Button>
      </Page>
    </>
  );
};
